<template>
  <client-only>
    <div>
      <v-layout wrap column class="cv-send-popup-wrap">
        <v-layout mb-1>
          <v-flex class="px-4">
            <v-flex class="mob-view">
              <v-btn
                color="secondary"
                class="pa-0"
                min-width="auto"
                width="24"
                text
                @click="closePopup()"
              >
                <v-icon class="display-m-30">mdi-arrow-right</v-icon>
              </v-btn>
            </v-flex>
            <p class="mb-1">{{ cvPopup.applyToJob }}</p>
            <p class="display-28 font-weight-medium mb-0">{{ FullName }}</p>
            <p
              v-if="AllowNoCV"
              class="primary--text"
              v-html="cvPopup.noCvAttention"
            ></p>
          </v-flex>
          <v-flex class="text-left x-close pc-view">
            <v-btn color="primary large" text @click="closePopup()">
              <v-icon class="icon-forma-1-2 display-16" size="20" />
            </v-btn>
          </v-flex>
        </v-layout>
        <CVFiles
          v-show="currUser && !AllowNoCV"
          :display-all="false"
          :display-show-btn="true"
          @fileChosen="handleChosenFile"
        />
        <Spinner v-show="!currUser" />
        <CVDetails
          v-show="currUser"
          ref="details"
          :is-complete-details="
            AllowNoCV ? AllowNoCVUserDetailsDisplay : isComplete
          "
          @enableSendCV="handleEnableSendCV"
          :AllowNoCV="AllowNoCV"
          />

        <v-flex
          v-show="currUser"
          class="content-block txtarea"
          pt-2
          pb-2
          pl-4
          pr-4
        >
          <p class="mb-2">
            <span
              class="primary--text display-24 pointer"
              @click="toggleLetterField"
            >
              {{ plusSign }}
            </span>
            <span
              class="display-18 d-inline pr-2 pointer"
              @click="toggleLetterField"
            >
              {{ cvPopup.addPersonalLetter }}
            </span>
          </p>
          <v-textarea
            v-if="displayLetter"
            solo
            placeholder="הכנס לכאן מכתב מקדים..."
            v-model="PreliminaryLetter"
          />
        </v-flex>

        <v-flex v-show="currUser" pb-4 pl-4 pr-2>
          <SendToSimilarJobs
            v-if="showSimilarJobsCheckBox"
            @sendToSimilarJobs="sendToSimilar"
          />
        </v-flex>

        <v-flex v-if="!enableSend" v-show="currUser" mt-2 mb-1 pl-4 pr-4>
          <small class="red--text">
            <strong>{{ cvPopup.isCompleteDetails }}</strong>
          </small>
        </v-flex>

        <v-flex v-show="msgError" mt-2 mb-1 pl-4 pr-4>
          <p class="red--text">
            <strong>{{ msgError }}</strong>
          </p>
        </v-flex>

        <v-flex xs12 text-center class="flex-basis-auto" px-3>
          <v-row>
            <v-col v-if="hasFilters" cols="12" class="text-right px-4">
              <v-form v-model="filtersFormvalid" vlaidate class="filters-form">
                <p class="display-18 filters-hdr">
                  כדי לשלוח קורות חיים למשרה זו יש לענות על דרישות חובה:
                </p>
                <v-flex v-for="(item, index) in jobFilters" :key="index">
                  <v-checkbox
                    hide-details
                    :label="item"
                    class="mt-1 black--text display-16"
                    required
                    dense
                    :rules="[(v) => !!v || '']"
                  />
                </v-flex>
              </v-form>
            </v-col>
            <v-col cols="12" class="text-left" pl-7>
              <v-btn
                id="submitApply"
                rounded
                :loading="inProgress"
                :disabled="
                  !hasFilters
                    ? !enableSend || (!file && !AllowNoCV)
                    : !enableSend || (!file && !AllowNoCV) || !filtersFormvalid
                "
                @click="sendDetailsUpdate"
                :color="'#1caf6b'"
              >
                <span v-if="AllowNoCV">
                  <img src="/tap.png" alt="TAP" width="12px" />
                  {{ cvPopup.applyWithoutCv }}
                </span>
                <span v-else>{{ cvPopup.applyCv }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </div>
  </client-only>
</template>

<script>
import drushim_lodash from 'lodash';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import CVDetails from '@/components/Dialogs/CV_Popup/CVDetails';
import CVFiles from '@/components/Dialogs/CV_Popup/CVFiles';
import SendToSimilarJobs from '@/components/Forms/Form_Fields/SendToSimilarJobs';
import Spinner from '@/components/Spinner/Spinner';
import gtm from '@/lib/gtm';
import CurrentUser from '@/components/mixins/CurrentUser';
import { SEND_SINGLE_CV } from '@/lib/api.js';

function cvSendConfirmData(responseArray) {
  const { SentDate } = responseArray[0];

  return SentDate;
}

export default {
  mixins: [CurrentUser],
  components: {
    CVFiles,
    CVDetails,
    SendToSimilarJobs,
    Spinner
  },

  props: {
    jobFilters: {
      type: Array,
      required: false,
      default: () => []
    },
    hasFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    ssasource: {
      type: Number,
      required: false,
      default: 0
    },
    isAA: {
      type: Boolean,
      required: false,
      default: false
    },

    FullName: {
      type: String,
      required: false,
      default: ''
    },
    Code: {
      type: Number,
      required: false,
      default: 0
    },
    jobIndex: {
      type: Number,
      required: false,
      default: 0
    },
    JobAnalytics: {
      type: Object,
      required: false
    },
    isJobOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    AllowNoCV: {
      type: Boolean,
      required: true,
      default: false
    },
    IsRecommender: {
      type: Boolean,
      required: false,
      default: false
    },
    WhatFieldText: {
      type: String,
      required: false,
      default: ''
    },
    currentPage: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      filtersFormvalid: false,
      filtersTitleHeb: 'דרישות חובה',
      filtersTitleEn: 'Mandatory Requirements',
      filterModel: [],
      cvPopup: t('titles.CV_Popup'),
      inProgress: false,
      file: '',
      displayLetter: false,
      //adding cv letter text
      letterTxt: '',
      sendingDate: undefined,
      plusSign: '+',
      enableSend: false,
      showSimilarJobsCheckBox: true,
      msgError: null,
      ssaData: null,
      goal8: null,
      PreliminaryLetter: ''
    };
  },

  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },

    currUser() {
      return this.CurrentUser;
    },
    isComplete() {
      return (
        this.CurrentUser &&
        this.CurrentUser.Profile &&
        this.CurrentUser.Profile.IsComplete &&
        /[0][5]\d{8}$/.test(this.CurrentUser.Profile.Phone)
      );
    },
    AllowNoCVUserDetailsDisplay() {
      if (
        this.CurrentUser &&
        this.CurrentUser.FirstName &&
        this.CurrentUser.LastName &&
        this.CurrentUser.Email &&
        this.CurrentUser.Profile.Experience &&
        /[0][5]\d{8}$/.test(this.CurrentUser.Profile.Phone)
      ) {
        return true;
      }
      return false;
    },
    location() {
      return this.CurrentUser && this.CurrentUser.Profile
        ? this.CurrentUser.Profile.Location
        : null;
    }
  },

  mounted() {
    this.fetchUserProfile();
    this.sendEnable();
  },

  methods: {
    sendSSA(evenData) {
      this.ssa.logResponse('LogSSA', evenData);
    },
    sendToSimilar(val) {
      /**
       * @param {Boolean} val , value form SendToSimilarJobs
       * emit to CVUserDetailsEdit
       */
      this.$nuxt.$emit('sendToSimilar', val);
    },
    sendEnable() {
      this.enableSend = this.isComplete;
    },

    handleEnableSendCV(val) {
      this.enableSend = val;
    },

    // move to outside common function
    async fetchUserProfile() {
      this.$auth.fetchUser();
      /**
       * @param {null} showSimilarJobsCheckBox showSimilarJobsCheckBox checkbox if  is null only
       */
      this.showSimilarJobsCheckBox =
        this.CurrentUser.Profile.SendToSimilarJobs === null;

      this.sendEnable();
    },

    // send update user details
    async sendDetailsUpdate() {
      try {
        this.inProgress = true;
        this.msgError = null;
        const { error, valid } = await this.saveDetails();

        if (!error && valid) {
          await this.sendCV();
        } else if (error) {
          throw error;
        }
      } catch (e) {
        console.log('sendDetailsUpdate', e);
        this.msgError = 'שגיאת שליחה';
        this.inProgress = false;
      } finally {
        this.inProgress = false;
      }
    },

    saveDetails() {
      return this.$refs.details.saveDetails();
    },

    async sendCV() {
      if (this.file || this.AllowNoCV) {
        this.inProgress = true;
        this.msgError = null;
        /**
         * Add query param to AA test, only on serach results jobs
         * @see jobsOnDrushim.vue added to jobItem
         * @param {Boolean} isAA
         * @return {String}
         */
        let aaTestParam = this.isAA ? `&isAA=${this.isAA}` : '';
        let user_sParam = this.$route.query.user_s ? `&user_s=real_new` : '';

        let { query } = this.$route;
        let { sag, tid, ac, platinum } = query;
        let platinumParam = platinum ? `&platinum=${platinum}` : '';

        let postdata = {
          Index: this.jobIndex,
          AllowNoCV: this.AllowNoCV,

          PreliminaryLetter: this.PreliminaryLetter,
          ...(sag && { SmartAgentGroup: sag }),
          ...(tid && { TestId: tid }),
          ...(ac && { AgentCode: ac })
        };

        await this.$axios
          .post(
            `${SEND_SINGLE_CV}?JobCode=${this.Code}&cvc=${this.checkForFileCode(
              this.file
            )}${aaTestParam}&ssasource=${
              this.ssasource
            }${user_sParam}${platinumParam}`,
            postdata
          )
          .then(res => {
            if (res.data.IsError) {
              /**
               * get the first key value
               */
              let value = Object.keys(res.data.Errors)[0];
              throw value;
            }
            if (res.data.Successful.length > 0) {
              this.sendingDate = cvSendConfirmData(res.data.Successful);
              this.ssaData = res.data.SSAEvents;

              this.sendSSA(this.ssaData);
            }

            if (res.data.Failed.length > 0) {
              // this.alertFailed();
              this.inProgress = false;
              let value = Object.keys(res.data.Errors)[0];
              throw value;
              // throw res.data.Failed;
            }
            this.goal8 =
              res.data.QueryParams.Goal8.length > -1
                ? res.data.QueryParams.Goal8
                : false;
          })
          .then(() => {
            this.fetchUserProfile();
            // close cv dialog & open confirmation dialog
            this.confirmSendCV();
            /**
             * gtm from @/lib/gtm'
             *  @param  {data} the gtm dataLayer
             */

            if (this.AllowNoCV) {
              gtm({
                category: 'send_no_cv',
                // action: 'חיפוש',
                label: this.FullName,
                event: 'משרות_ללא_קוח'
              });

              gtm({
                event_name: 'send_no_cv',
                // place: 'חיפוש',
                no_CV_name: this.FullName,
                event: 'משרות_ללא_קוח_GA4'
              });
            }

            if (this.goal8)
              gtm({
                event: this.goal8
              });

            gtm({
              event: 'send_all_cv',
              jobtype: this.isJobOpen ? 'open' : 'close',
              'gtm.uniqueEventId': 59,
              gaCategory: 'event',
              gaAction: 'complete',
              gaLabel: 'all_send_cv',
              send: 'regular',
              cd71: this.IsRecommender ? 'yes' : 'no',
              search: this.WhatFieldText,
              job_name_cv: this.FullName,

              cd70: this.IsRecommender ? this.currentPage : null, // currentPage - place of recommened job
              recommender: this.IsRecommender ? 'recommender cv' : null, //similar to cd71 , requested by seo
              JOBCODE: this.Code
            });
            gtm({
              email: this.CurrentUser.Email,
              phone: this.CurrentUser.Profile.Phone,
              event: 'cv_gads'
            });
            gtm({
              SEKERCODE: this.CurrentUser.Profile.SeekerCode,
              JOBCODE: this.Code,
              DATETIME: new Date().toLocaleString(),
              event: 'send_all_cv_extra_data'
            });

            const transactionDataLayer = {
              event: 'transaction',
              ecommerce: {
                purchase: {
                  actionField: {
                    id: drushim_lodash.get(this.JobAnalytics, 'TransactionId'),
                    affiliation: 'drushim',
                    ...drushim_lodash.pick(this.JobAnalytics, ['revenue', 'tax', 'shipping'])
                  },

                  products: [
                    drushim_lodash.pick(this.JobAnalytics, [
                      'name',
                      'id',
                      'price',
                      'brand',
                      'category',
                      'variant',
                      'quantity'
                    ])
                  ]
                }
              },
              'gtm.uniqueEventId': 2282
            };
            gtm(transactionDataLayer);
            this.inProgress = false;
          })
          .catch(e => {
            console.log('send cv', e);
            switch (e) {
              case 'ExceededDailyCvSubmissionsLimit':
                this.msgError =
                  'הגעת למכסת השליחות היומית שלך. אנא נסה לשלוח שוב מחר!';
                this.inProgress = false;
                break;
              default:
                this.msgError = 'שגיאת שליחה';
                this.inProgress = false;
                break;
            }
          });
      }
    },

    handleChosenFile(file) {
      this.file = file;
    },

    checkForFileCode(file) {
      if (file && !this.AllowNoCV) {
        return file.Code;
      } else {
        return null;
      }
    },

    closePopup() {
      this.$emit('closeDialog');
    },

    toggleLetterField() {
      this.displayLetter = !this.displayLetter;
      this.plusSign = this.displayLetter ? '-' : '+';
    },

    /**
     * sends emit to cvButton...
     */
    confirmSendCV() {
      this.$emit('confirmSend');
    },

    /**
     * * @jobCode { number }
     * emiting to CVDialog that sent cv not succeded
     */
    alertFailed(jobCode) {
      this.$nuxt.$emit('alertCVSendFailed', jobCode);
    }
  }
};
</script>

<style lang="scss" scoped>
#submitApply {
  color: #fff;
  width: 100%;
  height: 35px;
}
.content-block {
  border-radius: 5px;
  background-color: #f8f6fa;
  margin: 5px;
}

.cv-send-popup-wrap {
  object-fit: contain;
  border-radius: 20px;
}
.cv-send-popup-wrap:after {
  content: '';
  opacity: 0.46;
  background-color: #212121;
}

.align-vertical {
  margin-bottom: 20px;
}

.x-close {
  position: absolute;
  left: 0;
  top: 10px;
  z-index: 5;
}
.tap-img {
  vertical-align: bottom;
  margin-left: 2px;
}
@media screen and (min-width: 600px) {
  .content-block {
    margin: 10px;
  }
  #submitApply {
    width: 120px;
    height: 36px;
  }
}

.filters-hdr {
  font-weight: 500;
}
.filters-form {
  border-top: 1px solid #f6f7f9;
}
@media screen and (max-width: 900px) {
  .cv-send-popup-wrap {
    padding: 0 5px;
  }
}
</style>
